import React from 'react'
import ClientLayout from '../layout/ClientLayout'
import { useParams } from 'react-router-dom'

function ClientInfoPage() {
  const {clientId} = useParams()
  return (
    <ClientLayout>
      <div>ClientInfoPage {clientId}</div>
    </ClientLayout>
  )
}

export default ClientInfoPage